<div class='container-fluid'>
  <div class='body-content'>
    <router-outlet></router-outlet>
  </div>
</div>